import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import {Smartphone, Menu, X} from 'lucide-react'

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const location = useLocation()

  const isActive = (path: string) => location.pathname === path

  return (
    <header className="bg-blue-950 border-b border-red-600/30 sticky top-0 z-50">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2 group">
            <div className="bg-red-600 p-2 rounded-lg group-hover:bg-red-500 transition-colors">
              <Smartphone className="w-6 h-6 text-white" />
            </div>
            <span className="text-2xl font-bold text-white">Texting<span className="text-red-500">Santa</span></span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className={`text-lg font-medium transition-colors ${
                isActive('/') ? 'text-red-500' : 'text-white hover:text-red-400'
              }`}
            >
              Home
            </Link>
            <Link
              to="/tracker"
              className={`text-lg font-medium transition-colors ${
                isActive('/tracker') ? 'text-red-500' : 'text-white hover:text-red-400'
              }`}
            >
              Santa Tracker 2025
            </Link>
            <Link
              to="/blog"
              className={`text-lg font-medium transition-colors ${
                isActive('/blog') ? 'text-red-500' : 'text-white hover:text-red-400'
              }`}
            >
              Blog
            </Link>
            <Link
              to="/faq"
              className={`text-lg font-medium transition-colors ${
                isActive('/faq') ? 'text-red-500' : 'text-white hover:text-red-400'
              }`}
            >
              FAQ
            </Link>
            <Link
              to="/contact"
              className={`text-lg font-medium transition-colors ${
                isActive('/contact') ? 'text-red-500' : 'text-white hover:text-red-400'
              }`}
            >
              Contact
            </Link>
            <button className="bg-red-600 hover:bg-red-500 text-white px-6 py-2 rounded-full font-semibold transition-all transform hover:scale-105">
              Start Texting Santa
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden text-white p-2"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 space-y-4">
            <Link
              to="/"
              onClick={() => setMobileMenuOpen(false)}
              className={`block text-lg font-medium ${
                isActive('/') ? 'text-red-500' : 'text-white'
              }`}
            >
              Home
            </Link>
            <Link
              to="/tracker"
              onClick={() => setMobileMenuOpen(false)}
              className={`block text-lg font-medium ${
                isActive('/tracker') ? 'text-red-500' : 'text-white'
              }`}
            >
              Santa Tracker 2025
            </Link>
            <Link
              to="/blog"
              onClick={() => setMobileMenuOpen(false)}
              className={`block text-lg font-medium ${
                isActive('/blog') ? 'text-red-500' : 'text-white'
              }`}
            >
              Blog
            </Link>
            <Link
              to="/faq"
              onClick={() => setMobileMenuOpen(false)}
              className={`block text-lg font-medium ${
                isActive('/faq') ? 'text-red-500' : 'text-white'
              }`}
            >
              FAQ
            </Link>
            <Link
              to="/contact"
              onClick={() => setMobileMenuOpen(false)}
              className={`block text-lg font-medium ${
                isActive('/contact') ? 'text-red-500' : 'text-white'
              }`}
            >
              Contact
            </Link>
            <button className="w-full bg-red-600 hover:bg-red-500 text-white px-6 py-2 rounded-full font-semibold">
              Start Texting Santa
            </button>
          </div>
        )}
      </nav>
    </header>
  )
}
